import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectsDirectoryRoute: InvariantJiraRoute = {
	name: 'projects-directory',
	path: '/jira/projects',
	exact: true,
	query: ['csm_onboarding?'],
};
